import React, { useRef, useState } from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import tituloGaleria from "../../assets/images/png/tituloGaleria.png";
import comingSoon from "../../assets/images/png/comingSoon.png";
import tituloNews from "../../assets/images/png/tituloNews.png";
import cardNews from "../../assets/images/svg/cardNews.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "./index.css";
import setaEsquerda from "../../assets/images/svg/setaEsquerda.svg";
import setaDireita from "../../assets/images/svg/setaDireita.svg";
import news1 from "../../assets/images/png/news1.png";
import news2 from "../../assets/images/png/news2.png";
// Importando todas as fotos de 1 a 30
const fotos = [];
for (let i = 1; i <= 30; i++) {
  fotos.push(require(`../../assets/images/png/fotos/fotos (${i}).jpg`));
}

const pelucias = fotos.map((foto, index) => ({
  src: foto,
  name: "",
}));

export default function Galeria() {
  const navigate = useNavigate();
  const swiperRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handlePrevClick = () => {
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const handleNextClick = () => {
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };
  const swiperNewsRef = useRef(null);
  const handlePrevClickNews = () => {
    swiperNewsRef.current?.swiper.slidePrev();
  };

  const handleNextClickNews = () => {
    swiperNewsRef.current?.swiper.slideNext();
  };

  const handleCardClick = (pelucia) => {
    setSelectedImage(pelucia);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedImage(null);
  };
  return (
    <div>
      {/* <img width={"100%"} src={comingSoon} alt="Coming Soon" className="coming-soon-image" /> */}
      <div className="galeria-container position-relative">
        {/* Background Decoration */}
        <div className="galeria-meiaLua">
          <div className="galeria-quadradoLua"></div>
        </div>

        {/* Main Content */}
        <div className="container container-galeria">
          <div className="container d-flex justify-content-center align-items-center py-5">
            <img
              className="setaCards"
              src={setaEsquerda}
              alt="Previous gallery slide"
              onClick={handlePrevClick}
            />
            <img
              width={"30%"}
              src={tituloGaleria}
              alt="Clawz Entertainment Gallery - Exclusive Plush Collection"
            />
            <img
              className="setaCards"
              src={setaDireita}
              alt="Next gallery slide"
              onClick={handleNextClick}
            />
          </div>

          <Swiper
            ref={swiperRef}
            style={{ padding: "10px", width: "80%" }}
            pagination={{
              clickable: true,
            }}
            loop={true}
            slidesPerView={1}
            spaceBetween={30}
            autoplay={{
              delay: 9000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
            modules={[Autoplay, Navigation]}
            className="mySwiper"
          >
            {pelucias.map((pelucia, index) => (
              <SwiperSlide key={index}>
                <div
                  className="galeria-card"
                  onClick={() => handleCardClick(pelucia)}
                >
                  <img
                    src={pelucia.src}
                    alt={`${pelucia.name} - Clawz Exclusive Plush Collection`}
                  />
                </div>
                <h2 className="galeria-card-title">{pelucia.name}</h2>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="titulo-galeria-news">
            <div className="container d-flex justify-content-center align-items-center pt-5">
              <img
                className="setaCards"
                src={setaEsquerda}
                alt="Previous news slide"
                onClick={handlePrevClickNews}
              />
              <img
                width={"25%"}
                src={tituloNews}
                alt="Clawz Entertainment News - Latest Updates"
              />
              <img
                className="setaCards"
                src={setaDireita}
                alt="Next news slide"
                onClick={handleNextClickNews}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="galeria-container ">
        <div className="container mt-3">
          <Swiper
            ref={swiperNewsRef}
            pagination={{
              clickable: true,
            }}
            loop={true}
            slidesPerView={1}
            spaceBetween={10}
            autoplay={{
              delay: 9000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay, Navigation]}
            className="mySwiper"
          >
            <SwiperSlide>
              <img
                style={{ width: "100%", paddingBottom: 50 }}
                src={news1}
                alt="Clawz Entertainment Latest News and Updates"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                style={{ width: "100%", paddingBottom: 50 }}
                src={news2}
                alt="Clawz Entertainment Latest News and Updates"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>

      {/* Modal */}
      {modalOpen && selectedImage && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={handleCloseModal}>
              ✕
            </button>
            <div className="modal-image-container">
              <img
                src={selectedImage.src}
                alt={`${selectedImage.name} - Clawz Exclusive Plush Collection`}
                className="modal-background-image"
              />
              <div className="modal-background-overlay"></div>
              <img
                src={selectedImage.src}
                alt={`${selectedImage.name} - Clawz Exclusive Plush Collection`}
                className="modal-image"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
